<template>
  <v-dialog v-model="dialog" max-width="300px" persistent>
    <v-card>
      <v-card-title>Alert</v-card-title>
      <v-card-text>File uploaded successfully!</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="green" @click="done()">
          Okay
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: true
    };
  },
  methods: {
    done() {
      location.href = "https://www.317rental.com/";
    }
  }
};
</script>

<style></style>
